<template>
  <div class="list">
    <sr-loading v-if="loading"/>
    <sr-list v-else>
      <sr-list-item v-for="(item, index) in listData" :key="index" :img="item.defaultImage" :go="item.storeSysno" @click="go">
        <div class="sr-list-txt">
          <p class="p1" :title="item.storeName">{{item.storeName}}</p>
          <p class="p2">{{item.address}}</p>
          <p class="p3" :title="item.detail">{{item.detail}}</p>
        </div>
      </sr-list-item>
    </sr-list>
  </div>
</template>

<script>
  import axios from 'axios'
  import SrLoading from '@/components/loading'
  import srList from '@/components/list'
  import srListItem from '@/components/list/item'
  export default {
    components: {
      SrLoading,
      srList,
      srListItem
    },
    data () {
      return {
        loading: true,
        listData: []
      }
    },
    methods: {
      restaurant () {
        axios.post('/node/api/restaurant', {
          pageNum: 1,
          pageSize: 100,
          xCoord: 38.8,
          yCoord: 116
        }).then(res => {
          if (res.data.code === 9999) {
            this.listData = res.data.data
            this.loading = false
          }
        })
      },
      go (v) {
        this.$router.push({
          path: '/restaurant-detail/' + v
        })
      }
    },
    created () {
      this.restaurant()
    }
  }
</script>

<style lang="less" scoped>
  .list {
    width: 1200px;
    margin: 0 auto;
    .tab {
      padding: 16px 0 0 8px;
    }
    .sr-list-txt {
      height: 60px;
      line-height: 20px;
      text-align: center;
      p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .p1 {
        color: #333;
      }
      .p2 {
        font-size: 12px;
        color: #666;
      }
      .p3 {
        color: #b0b0b0;
        font-size: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/restaurant/index.vue